var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarningV2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.4585V10.8335",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5665 7.14987V12.8498C17.5665 13.7832 17.0665 14.6499 16.2582 15.1249L11.3082 17.9832C10.4998 18.4499 9.49981 18.4499 8.68315 17.9832L3.73314 15.1249C2.92481 14.6582 2.4248 13.7915 2.4248 12.8498V7.14987C2.4248 6.21653 2.92481 5.34983 3.73314 4.87483L8.68315 2.0165C9.49148 1.54984 10.4915 1.54984 11.3082 2.0165L16.2582 4.87483C17.0665 5.34983 17.5665 6.2082 17.5665 7.14987Z",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5V13.5833",
    stroke: "#46515A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningV2);
export default __webpack_public_path__ + "static/media/ic_warning_v2.98e8b0d34f7231d9d75be28e1de81987.svg";
export { ForwardRef as ReactComponent };